// extracted by mini-css-extract-plugin
module.exports = {"container":"e_r2","buttonPrev":"e_s2","buttonNext":"e_t2","hidden":"e_u2","iconPrev":"e_v2","iconNext":"e_w2","scrollView":"e_x2","card":"e_y2","scroller":"e_z2"};